module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-1"
  }, [(_vm.wSat == 0) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "dvsWait"
  }) : _vm._e(), _vm._v(" "), (_vm.wSat == 2) ? _c('div', {
    staticClass: "succedTips"
  }, [_vm._v("\n    材料已提交至省局，可从\n    "), _c('router-link', {
    attrs: {
      "to": "pgress_step"
    }
  }, [_c('a', [_vm._v("核验进度")])]), _vm._v(" 菜单查看审核进度。\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('div', [(_vm.frashCode) ? _c('MainTabs', {
    attrs: {
      "pressType": "1",
      "pressDat": _vm.resDat
    },
    on: {
      "go-frash": _vm.frashHandle,
      "valChangeSearch": _vm.valChangeSearch
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6f7bdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/audioPress.vue
// module id = 1781
// module chunks = 1